<script lang="ts">
	import { FileUploader, type UploadCompletion, type UploadError } from "file-uploader"
	import { LuxedoRPC } from "luxedo-rpc"
	import BrightnessBoostInput from "./BrightnessBoostInput.svelte"
	import { type BrightnessBoostValue } from "./types"

	interface Props {
		sceneId: number
		sceneName: string
		projectFolder: number
		selectedDeviceId: number
		postUpload: (result: UploadCompletion) => void
		onError?: (error: UploadError) => void
		triggerUpload: () => void
		triggerCancel: () => void
	}

	let {
		sceneId,
		sceneName,
		projectFolder,
		selectedDeviceId,
		postUpload,
		onError,
		triggerUpload = $bindable(),
		triggerCancel = $bindable(),
	}: Props = $props()

	let isUploading: boolean = $state()
	let deepFry: BrightnessBoostValue = $state()
</script>

{#if !isUploading}
	<div class="flex-row heading-row">
		<h3 class="upload-header">Upload your project</h3>

		<BrightnessBoostInput bind:value={deepFry} />
	</div>
{/if}
<FileUploader
	getUploadToken={async () =>
		(await LuxedoRPC.api.upload.tus_upload_token({ upload_type: "scene", entry_id: sceneId })).upload_token}
	uploadType="scene"
	maxFileLimit={1}
	allowedMimeTypes={["video/mp4", "video/quicktime"]}
	endpoint={import.meta.env.VITE_UPLOAD_URL}
	meta={{
		entry_id: sceneId,
		deep_fry: deepFry,
		device_id: selectedDeviceId,
		folder_id: projectFolder,
		title: sceneName,
	}}
	onAllComplete={postUpload}
	{onError}
	bind:isUploading
	bind:triggerUpload
	bind:clearUploads={triggerCancel}
/>

<style>
	.heading-row {
		justify-content: space-between;
		margin-bottom: 1rem;
	}
</style>
